import * as React from 'react';

function SvgIconInitialSelected(props) {
  return (
    <svg viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle fill="#E2F4F2" cx={28} cy={28} r={28} />
        <path
          d="M31.75 38.66h3.85c.5 0 .9-.4.9-.9V26.8h2.17c.36 0 .5-.12.56-.3.06-.15.03-.34-.23-.57l-2.1-1.82c-.2-.19-.37-.56-.4-.89v-3.47a.9.9 0 00-.9-.91h-1.66a.91.91 0 00-.86.6l-.37 1.05-.83-.72-3.22-2.78a1 1 0 00-.66-.24c-.25 0-.48.09-.66.24L17 25.93c-.27.23-.29.42-.23.58.06.17.2.29.56.29h2.16v10.95c0 .5.41.91.91.91h3.85V34c0-1.24 1-2.25 2.25-2.25h3c1.24 0 2.25 1 2.25 2.25v4.66zm6.26-.9a2.41 2.41 0 01-2.41 2.4h-5.35V34a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75v6.16H20.4a2.41 2.41 0 01-2.41-2.4V28.3h-.66c-1.07 0-1.7-.57-1.96-1.27-.26-.7-.15-1.54.65-2.23l10.34-8.95a2.52 2.52 0 013.29 0l2.55 2.22a2.4 2.4 0 011.74-.73h1.66a2.41 2.41 0 012.4 2.4v3.35l1.98 1.7c.8.7.92 1.55.66 2.24-.26.7-.9 1.27-1.97 1.27h-.66v9.45z"
          fill="#38B2A6"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}

export default SvgIconInitialSelected;
